import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-download.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const DownloadIcon = createSvgIcon(<Icon />, 'DownloadIcon');
